import React, { memo } from 'react';
import styled from 'styled-components';
import { withScreenSize } from '../../../common/utilities/withScreenSize.jsx';
import { HourlyForecastCardsList } from '../../common/hourlyForecastCardsList';
import { PageContentContainerStyle } from '../../styles';
import { Next12Hours } from '../pagination/next12Hours';

interface MobileHourlyForecastViewProps {
    isMobile: boolean;
}

export const MobileHourlyForecastView = memo(withScreenSize(({ isMobile }: MobileHourlyForecastViewProps) => {
    if (!isMobile) {
        return null;
    }

    return (
        <Container>
            <HourlyForecastCardsList />
            <Next12Hours />
        </Container>
    );
}));

const Container = styled.div`
    ${PageContentContainerStyle}
    flex-direction: column;
`;